/**
 * Object for handling user marks (annotations)
 * Initialize in main.js, if needed
 */

import  FetchHelpers from '../fetch-helpers';
import {AsyncNotice} from "../notices/notice";

/**
 * User mark object.
 *
 * Represents the collection of highlights (marks) an user has in a given book "page" (virtual section)
 * @constructor
 */
function UserMarks() {
    let u = this;

    /**
     * UserMark is initialized with values in '.section-content' and '.current-info' elements in the DOM
     */
    u.initialize = function(tagsOnly = false) {
        const sectionContent = document.querySelector('.section-content');
        const { dataset: { rootUrl = null } } = sectionContent;

        const currentInfo = document.querySelector('.current-info');
        const {
            dataset: {
                contentId = null,
                htmlContentId = null,
                sectionId = null,
                userId = null }
        } = currentInfo;

        u.contentId = contentId;
        u.fetchData = new FetchHelpers().fetchData;
        u.fetchUrl = rootUrl + 'books/fetch/marks.php';
        u.htmlContentId = htmlContentId;
        u.sectionId = sectionId;
        u.tagsOnly = tagsOnly;
        u.userId = userId;
    }

    /**
     * Load all marks a user has on a "page" (virtual section)
     * Sends the 'load' action along with the necessary data to fetch the desired collection of marks from the server
     * Async call is sent to fetch/marks.php
     * @returns {Promise<*>}
     */
    u.load = async function() {
        let data = {
            'action': 'load',
            'userId': u.userId ,
            'htmlContentId': u.htmlContentId,
            'contentId': u.contentId,
            'sectionId': u.sectionId
        }

        return await u.fetchData('POST', u.fetchUrl, data);
    }

    /**
     * Save the user's marks on a "page" (virtual section) to the database.
     * Sends the async call to marks.php in a 'data' object. the 'marks' property holds the collection of marks as
     * well as the necessary data in properties to uniquely associate the 'marks' collection to a given user and 'page'
     * (virtual section).
     * @param markData
     * @returns {Promise<*>}
     */
    u.save = async function(markData) {
        let data
          = { 'userId': u.userId,
              'htmlContentId': u.htmlContentId,
              'contentId': u.contentId,
              'sectionId': u.sectionId,
              'marks': markData,
              'tagsOnly': u.tagsOnly };
        return await u.fetchData('POST', u.fetchUrl, data);
    }

    u.saveMarks = async function(marksData) {
        try {
            const response = await u.save(marksData);
            if (response.success) {
                // console.log('Section marks saved to DB');
                return response;
            } else {
                if (response['error'] === 'Session expired.') {
                    const result = await u.sessionTimeout();
                    const root
                      = document.querySelector('.section-content').dataset.rootUrl
                      + 'books/async-redirect-home.php';
                    if (result['status'] === 'success') {
                        location.href = root;
                    }
                }

                return response;
            }
        } catch (error) {
            const message = 'There was an error updating this annotation. The error has been reported.';
            const notice = new AsyncNotice(message, 'error');
            const stack = error.stack.toString();

            await notice.create({message, error, stack}, true);
            notice.remove(5);

            return { success: false };
        }
    }

    u.sessionTimeout = async function() {
        u.url = document.querySelector('.section-content').dataset.rootUrl + 'books/async-redirect-home.php';
        let data = { 'userId': u.userId, 'msg' : 'Session timed out. Please sign in.' }

        return await u.fetchData('POST', u.fetchUrl, data)
    }
}

export default UserMarks;
